import axios from "axios";

// 请求拦截（
axios.interceptors.request.use(
  function (config) {
    const token = sessionStorage.getItem("token");
    var is_login = config.url.indexOf("Login") == -1 ? false : true;

    if (!is_login) {
      if (config.method == "post") {
        config.data.token = token;
      }
      if (config.method == "get") {
        config.params.token = token;
      }
    }
    return config;
  },
  function (error) {
    // 请求失败的处理
    return Promise.reject(error);
  }
);

// 响应拦截
axios.interceptors.response.use(
  function (response) {
    return response.data;
  },
  function (error) {
    // 处理响应失败
    return Promise.reject(error.response.data);
  }
);

export {
  axios
}


// WEBPACK FOOTER //
// ./src/util/axios.js